/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Standings_Help_PrivateInputs */



/**
* | output |
* | --- |
* | "Players see no standings until the finals start." |
*
* @param {Tfield_Standings_Help_PrivateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_standings_help_private = /** @type {((inputs?: Tfield_Standings_Help_PrivateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Standings_Help_PrivateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les joueurs ne voient aucun classement avant le début de la finale.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los jugadores no ven ninguna clasificación hasta que empieza la final.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Os jogadores não veem nenhuma classificação até a final começar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I giocatori non vedono alcuna classifica fino all'inizio della finale.")
	return /** @type {LocalizedString} */ ("Players see no standings until the finals start.")
});